const quotes: {
  [key: string]: {
    wizardComponent: string;
    wizardTitle: string;
    index: number;
  };
} = {
  "quote-introduction": {
    wizardComponent: "QuoteIntroduction",
    wizardTitle: "Introduction",
    index: 0,
  },
  "quote-questions": {
    wizardComponent: "QuoteQuestions",
    wizardTitle: "Questions",
    index: 1,
  },
  "quote-quote": {
    wizardComponent: "QuoteQuote",
    wizardTitle: "Quote",
    index: 2,
  },
  "quote-addon": {
    wizardComponent: "QuoteAddon",
    wizardTitle: "Add-On",
    index: 3,
  },
  "quote-account": {
    wizardComponent: "QuoteAccount",
    wizardTitle: "Account",
    index: 4,
  },
  "quote-checkout": {
    wizardComponent: "QuoteCheckout",
    wizardTitle: "Checkout",
    index: 5,
  },
  "quote-checkout-payment": {
    wizardComponent: "QuoteCheckout",
    wizardTitle: "Checkout",
    index: 6,
  },
  "quote-review": {
    wizardComponent: "QuoteReview",
    wizardTitle: "Review",
    index: 7,
  },
  "quote-done": { wizardComponent: "QuoteDone", wizardTitle: "Done", index: 8 },
  "quote-done-assurant-failed-api": {
    wizardComponent: "QuoteDoneFailedRentersApi",
    wizardTitle: "Renters failed",
    index: 9,
  },
  "quote-done-nssi-failed-api": {
    wizardComponent: "QuoteDoneFailedNssiApi",
    wizardTitle: "Personal failed",
    index: 10,
  },
  "quote-denied-ca": {
    wizardComponent: "QuoteDeniedCA",
    wizardTitle: "Quote denied",
    index: 11,
  },
  "quote-denied": {
    wizardComponent: "QuoteDeniedGeneric",
    wizardTitle: "Quote denied",
    index: 12,
  },
};

export default quotes;
